module.exports = __webpack_public_path__ + "img/logo-metis.fa42f31a.png";